import React from 'react';
import './Investors.css';
import Contact from '../common/components/contact/Contact';

function Investors() {
  return (
    <React.Fragment>
      <section className='investors'>
        <section className='hero'>
          <div className='title'>Investors</div>
        </section>
        <div className='container'>
          <div className='title'>Want to invest in Sera?</div>
          <div className='message'>If you'd like to invest in Sera, get in touch via the form below. We'll be launching our friends and family, seed and crowdfunding campaigns soon and we'll keep you updated on our progress.</div>
          <div className='investor-container'>
            <Contact isInvestor={true} />
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}

export default Investors;